<template>
  <div :class="$classTemplateCard[0]" :style="$sytleTemplateCard">
    <div class="w-100 h-100 p-5" :class="$classTemplateCard[1]">
      <slot name="title">
        <h2 v-if="title" class="font-weight-bold" :class="$classTitle">
          {{ title }}
        </h2>
      </slot>

      <div>
        <h3 v-if="price !== undefined && openToApply" class="font-size-xl">
          <price-displayer
            class="pt-2"
            :normal-price="price"
            :discount-price="discountPrice"
          ></price-displayer>
        </h3>

        <slot name="sub-title">
          <p v-if="subTitle">
            {{ subTitle }}
          </p>
        </slot>

        <slot name="body"></slot>

        <div class="d-flex flex-row align-items-center" :class="openToApply ? '' : 'pb-5'">
          <b-button
            v-if="openToApply"
            ref="button__buy-now"
            disable-event-track
            class="btn btn-lg btn-block"
            href="javascript:void(0);"
            :class="
              !userApplication && mcIsAlreadyCart && mcModeIsAlreadyCart
                ? 'button__go-to-cart'
                : 'button__buy-now'
            "
            :disabled="userApplication ? true : false || !eligible"
            :variant="$variantButton"
            @click="onClickBuyButton"
          >
            <span v-if="userApplication && mode && userApplication.mode === mode">Your plan</span>

            <span v-else-if="$_isFeatureEnabled('purchase_buynow')">
              <font-awesome-icon icon="cart-shopping" class="icon__cart-shopping" /> Buy now
            </span>

            <span v-else>Enroll</span>
          </b-button>

          <b-button
            v-else
            ref="button__interest"
            disable-event-track
            :disabled="(user && disabledButton) || interestFetching || !eligible"
            class="btn btn-lg btn-block button__interest"
            href="javascript:void(0);"
            variant="primary"
            @click="submitInterest"
          >
            <b-spinner v-if="interestFetching" small class="mb-u1" />
            <div v-else>
              <div v-if="disabledButton">You're signed for notification</div>
              <div v-else>Notify me</div>
            </div>
          </b-button>

          <b-button
            v-if="$_isFeatureEnabled('Cart') && openToApply && !userApplication"
            class="btn btn-lg button__add-to-cart ml-2 px-3"
            :variant="'outline-' + $variantButton"
            disable-event-track
            :disabled="userApplication || mcModeIsAlreadyCart ? true : false || !eligible"
            @click="onClickButtonCart"
          >
            <font-awesome-icon v-if="!isAdding" icon="cart-shopping" class="icon__cart-shopping" />
            <b-spinner v-if="isAdding" small />
          </b-button>

          <a
            v-if="!eligible"
            ref="tooltip"
            v-b-tooltip.click.v-light
            class="ml-3 icon__cannnot-apply-tool-tip"
            :title="eligibleMessage"
          >
            <font-awesome-icon
              icon="exclamation-circle"
              size="lg"
              style="color: #824224; cursor: pointer"
            />
          </a>
        </div>

        <slot name="footer"></slot>
      </div>
    </div>

    <redeem-code-modal
      :show.sync="activeModalRedeem"
      :mc-id="mc.id"
      :mode="mode"
      :success-alert-message="successAlertMessage"
      @redeem:success="redeemSuccess"
    ></redeem-code-modal>

    <base-modal :show.sync="activeModalChangeMode" title="Change plan">
      <span>Do you want to change plan ?</span>
      <template v-slot:modal-footer>
        <b-button variant="link" @click="activeModalChangeMode = false">Cancel</b-button>
        <b-button variant="success" @click="onChangeTypeMc">Confirm</b-button>
      </template>
    </base-modal>
  </div>
</template>

<script>
import PriceDisplayer from './PriceDisplayer.vue';
import LearningUnit from '@/models/LearningUnit';
import User from '@/models/User';
import Interest from '@/models/Interest';
import RedeemCodeModal from '@/components/LearningUnit/RedeemCodeModal.vue';
import Application from '@/models/Application';
import { notificationMixin } from '@/mixins/notificationMixin';
import { amplitudeMixin } from '@/mixins/amplitudeMixin';
import { BaseModal } from '@/components/base-components/index';
import Cart from '@/models/Cart';
import CartItem from '@/models/CartItem';
import LearningUnitOption from '@/models/LearningUnitOption';
import { optimizelyMixin } from '@/mixins/optimizelyMixin';
import { throttle } from 'lodash';

export default {
  name: 'CardMcDetail',

  components: {
    PriceDisplayer,
    RedeemCodeModal,
    BaseModal
  },

  mixins: [notificationMixin, amplitudeMixin, optimizelyMixin],

  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    mc: {
      type: LearningUnit,
      required: true
    },
    // price: {
    //   type: [Number, String]
    // },
    // discountPrice: {
    //   type: [Number, String]
    // },
    hilight: {
      type: Boolean,
      default: false
    },
    openToApply: {
      type: Boolean,
      default: false
    },
    user: {
      type: User,
      default: null
    },
    mode: {
      type: String,
      default: ''
    },
    order: {
      type: Number,
      default: 1
    },
    interestModes: {
      type: Array,
      default: () => []
    },
    eligible: {
      type: Boolean,
      default: false
    },
    eligibleMessage: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      activeModalRedeem: false,
      interestFetching: false,
      successAlertMessage:
        'Access code is successfully verified, you are now be able to access this MC.',
      activeModalChangeMode: false,
      isAdding: false
    };
  },

  computed: {
    $classTemplateCard() {
      return this.hilight
        ? [`order-${this.order} mb-5 mb-lg-0`, `card card__mc-detail--hilight`]
        : [
            `order-${this.order} mb-5 mb-lg-0 d-flex align-items-center`,
            `card card__mc-detail--non-hilight` +
              (this.openToApply ? '' : ' justify-content-center')
          ];
    },

    $sytleTemplateCard() {
      return this.hilight ? `z-index: 1000;` : ``;
    },

    $classTitle() {
      return this.hilight ? `` : `text-black-50`;
    },

    $variantButton() {
      return this.hilight ? `warning` : `primary`;
    },

    userInterest() {
      return this.user
        ? Interest.query()
            .where('learning_unit_id', this.mc.id)
            .where('user', this.user.id)
            .where((record) => {
              return this.interestModes.includes(record.mode);
            })
            .get()
        : [];
    },

    disabledButton() {
      return this.userInterest.length == this.interestModes.length;
    },

    userApplication() {
      return this.user
        ? Application.query()
            .where((apply) => {
              return apply.user.id == this.user.id && apply.learning_unit.id == this.mc.id;
            })
            .first()
        : null;
    },

    userCart() {
      return this.user ? Cart.query().where('user_id', this.user.id).first() : null;
    },

    mcIsAlreadyCart() {
      return this.userCart
        ? CartItem.query()
            .where('cart_id', this.userCart.id)
            .where('learning_unit_id', this.mc.id)
            .with('learning_unit_option')
            .first()
        : null;
    },

    mcModeIsAlreadyCart() {
      return this.mcIsAlreadyCart
        ? this.mcIsAlreadyCart.learning_unit_option.mode == this.mode
        : false;
    },

    learningUnitOption() {
      return LearningUnitOption.query()
        .where('learning_unit_id', this.mc.id)
        .where('option_type', 'ENTRY')
        .where('mode', this.mode)
        .first();
    },

    price() {
      return this.learningUnitOption ? this.learningUnitOption.price : 0;
    },

    discountPrice() {
      return this.learningUnitOption ? this.learningUnitOption.discount_price : 0;
    }
  },
  async mounted() {
    this.onClickButtonCart = throttle(this.onClickButtonCart, 5000);
    if (this.$route.query?.payload?.autoInterest) {
      await this.submitInterest();
    }
  },

  methods: {
    goToUserDashboardPage() {
      this.$router.push({ name: 'user-dashboard' });
    },

    redeemSuccess() {
      this.$emit('apply-fetching');
      this.goToUserDashboardPage();
    },

    goToSignInPageWithRedirect() {
      const previousRoute = this.$router.resolve({
        ...this.$route,
        params: {
          learningUnitId: this.mc.id
        }
      });

      this.$router.push({
        name: 'SignIn',
        query: {
          previousPath: previousRoute.href
        }
      });
    },

    onClickBuyButton(event) {
      if (!this.user) return this.goToSignInPageWithRedirect();

      let prop = {
        Plan: this.mode
      };

      if (this.$_isFeatureEnabled('purchase_buynow')) {
        //Buy now
        this.$router.push({
          name: 'checkout-option',
          params: { learningUnitOptionId: this.learningUnitOption.id },
          query: { previousPath: this.$route.fullPath }
        });
      } else {
        //Enroll
        this.activeModalRedeem = true;
      }
      this.$_amplitudeMixin_onClick(event.target, prop);
    },

    async onClickButtonCart(event) {
      if (!this.user) return this.goToSignInPageWithRedirect();
      this.isAdding = true;
      let prop = {
        Plan: this.mode
      };

      if (!this.mcIsAlreadyCart) {
        //Add to cart
        await Cart.api().addItem({
          learning_unit: this.mc.id,
          mode: this.mode
        });
        this.$toast.success(`MC added to cart successfully`);
        this.$emit('add-item:success');
      } else if (this.mcIsAlreadyCart && !this.mcModeIsAlreadyCart) {
        //Change type
        this.activeModalChangeMode = true;
        this.isAdding = false;
      }
      this.isAdding = false;
      this.$_amplitudeMixin_onClick(event.target, prop);
    },

    async onChangeTypeMc() {
      const { id, learning_unit_option } = this.mcIsAlreadyCart;

      let mode = learning_unit_option.mode == 'VERIFY' ? 'LEARN_VERIFY' : 'VERIFY';

      await CartItem.api().updateEntry(id, {
        mode
      });

      this.activeModalChangeMode = false;
      this.isAdding = false;
      this.$toast.success(`Your cart has been updated`);
    },

    async submitInterest(event = {}) {
      let target;
      if (!event) {
        target = this.$refs['button__interest'];
      } else {
        target = event.target;
      }
      const { interestModes } = this;
      await this.$_amplitudeMixin_onClick(target, {
        InterestModes: interestModes
      });

      if (!this.user) {
        return this.$router.push({
          name: 'SignIn',
          query: {
            previousPath: this.$route.path,
            payload: {
              autoInterest: true
            }
          }
        });
      }

      if (!this.eligible) return;

      this.interestFetching = true;

      let amplitudeLogMessage = '';

      try {
        for (let index = 0; index < interestModes.length; index++) {
          const mode = interestModes[index];

          const isAleradyInterest = this.userInterest.some((interest) => interest.mode === mode);

          if (isAleradyInterest) {
            continue;
          }

          await Interest.api().createByLearner(this.mc.id, mode);
        }

        this.notiSuccessDefault('You have been subscribed to this micro-credential.');
      } catch (error) {
        if (error.response?.data?.message === 'this user already interest this learning unit') {
          amplitudeLogMessage = error.response.data.message;
        } else {
          amplitudeLogMessage = 'signign for interest fail.';
        }

        this.notiErrorDefault(amplitudeLogMessage);
      } finally {
        await this.$_amplitudeMixin_onCheck({
          InterestMode: interestModes,
          Message: amplitudeLogMessage
        });
      }

      this.interestFetching = false;

      //clear params auto submit interest
      if (this.$route.query?.payload?.autoInterest) {
        this.$router.replace({
          path: this.$route.fullPath.replace(/(\?.*)|(#.*)/g, '')
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  &__mc-detail--hilight {
    color: #fff !important;
    background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    box-shadow: 0 1rem 3rem rgba(7, 9, 25, 0.57) !important;
  }

  &__mc-detail--non-hilight {
    background-color: #f8f9ff !important;
  }
}

.button__add-to-cart.btn-outline-warning {
  &:disabled {
    background-color: white !important;
  }

  &:not(:hover) {
    background-color: white;
  }
}
</style>
